export default "__VITE_ASSET__BQAjZbSr__"